<template>
  <div class="wrap" v-loadmore="loadmore">
    <div class="top-box">
      <div>
        <div class="num">{{balance}}</div>
        <div>人人道积分</div>
      </div>
      <a :href="shopUrl" class="out-link">
        <div class="num">
          <img src="~common/image/shop.png" alt="">
        </div>
        <div>积分商城</div>
      </a>
      <div class="line"></div>
    </div>
    <div class="list">
      <div class="title border-bottom">
        记录<router-link tag="span" to="/personal/integral/rule">如何获得元积分？</router-link>
      </div>
      <div class="con">
        <div class="item border-bottom" v-for="(item,index) in list" :key="index">
          <div class="left">
            <div class="name">{{item.rule}}</div>
            <div class="time">{{item.updated_at}}</div>
          </div>
          <div class="right">+{{item.value}}</div>
        </div>
      </div>
    </div>
    <!-- 到底了 -->
    <div class="end" v-if="loaded">
      <div></div>
      <span class="text">已经到底啦</span>
      <div></div>
    </div>
    <loading v-show="loading"></loading>
  </div>
</template>

<script>
import {RES_OK} from '@/api/config'
import {getInfo} from '@/api/integral'
import {isBind} from '@/api/user-center'
import Loading from 'components/base/loading/loading.vue'
export default {
  data() {
    return {
      balance: '0',
      page: 0,
      list: [],
      loaded: false,
      loading: false,
      phone: '',
      shopUrl: ''
    }
  },
  created() {
    isBind().then(({data}) => {
      if (data.code === RES_OK) {
        this.phone = data.data
        // 拼接跳转链接
        this.shopUrl = '/api/v1/platform_score/rrpoints?phone=' + this.phone
        this.getList()
      }
    })
  },
  methods: {
    getList() {
      if (this.loading) return
      this.loading = true
      const handler = ({data}) => {
        if (data.code === RES_OK) {
          this.balance = data.data.balance
          console.log(data.data.data.txn)
          if (data.data.data.txn) {
            this.list.push(...data.data.data.txn)
            this.page++
          }
          if (!data.data.data.txn || data.data.data.txn.length === 0) {
            this.loaded = true
          }
          this.loading = false
        }
      }
      getInfo(this.phone, this.page).then(handler)
    },
    loadmore() {
      if (this.loaded) return
      this.getList()
    }
  },
  components: {
    Loading
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    min-height 100vh
    background #ededed
    padding size(24)
  .top-box
    background-image linear-gradient(90deg, $color-theme 0%, lighten($color-theme, 35%) 100%)
    box-shadow 0px 2px 6px 0px rgba(104, 102, 102, 0.5)
    border-radius 4px
    min-height size(238)
    display flex
    align-items center
    color #fff
    text-align center
    position relative
    .line
      position absolute
      display block
      contetn ' '
      width 1px
      background #ffa665
      left 50%
      top 50%
      height size(110)
      margin-top size(-(110 / 2))
    >div,>.out-link
      display block
      color #fff
      flex 1
      font-size size(24)
    .num
      font-size size(84)
      img
        width size(70)
  .list
    margin-top size(24)
    background #fff
    border-radius 4px
    div:after,div:before
      background #fafafa
    .title
      line-height size(100)
      padding 0 size(30)
      font-size size(30)
      color #030303
      span
        float right
        color #4a90e2
        font-size size(24)
    .con
      padding 0 size(16)
    .item
      display flex
      align-items center
      min-height size(132)
      .name
        color #494949
        font-size size(28)
        margin-bottom size(16)
      .time
        color #969696
        font-size size(24)
      .left
        width 80%
      .right
        color #646464
        font-size size(28)
        text-align right
        width 20%
        padding-right size(12)
  .end
    display flex
    align-items center
    height size(33)
    color #cdcdcd
    font-size size(24)
    padding 0 size(46)
    margin-top size(24)
    .text
      padding 0 size(20)
    >div
      flex 1
      height 1px
      background #d0d0d0
</style>


// WEBPACK FOOTER //
// src/components/personal/integral/index.vue